import { useMemo } from 'react'
import { Col, Row } from 'antd'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { ImageType } from '../types'
import { useTranslations } from 'common/language'
import { BlockSectionTitle, BlockWrapper, BynderPicture, Container, CTALink, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


ImageGrid.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      heading: PropTypes.string,
      hover_text: PropTypes.string,
      cta_url: PropTypes.string,
      cta_link_type: PropTypes.string,
      cta_link_caption: PropTypes.string,
    })),
  }),
}

export default function ImageGrid({
  data = {
    items: [],
  },
}) {
  const { gettext } = useTranslations()
  const images = useMemo(() => get(data, 'items', []).map(({
    image,
    heading,
    hover_text: hoverText,
    cta_link: ctaLink,
    cta_link_caption: ctaCaption,
    cta_link_type: ctaType,
    image_size: imageSize,
  }, idx) => {
    const desktopImageProps = {
      maxWidth: 450,
      maxHeight: 300,
      sizes: '(max-width: 1440px) 28vw, 450px',
    }
    const desktopWideImageProps = {
      maxWidth: 910,
      maxHeight: 300,
      sizes: '(max-width: 1440px) 58vw, 910px',
    }
    return (
      <Col
        key={idx + heading}
        span={24}
        md={12}
        lg={imageSize === 'wide' ? 16 : 8}
        className={classNames.column}
      >
        <div className={classNames.imageContainer}>
          <div className={classNames.image}>
            <BynderPicture
              image={image}
              mobileImage={{
                maxWidth: 600,
                maxHeight: 500,
                sizes: '90vw',
              }}
              desktopImage={imageSize === 'wide' ? desktopWideImageProps : desktopImageProps}
            />
          </div>
          <div className={classNames.back}>
            <div>
              <Typography variant="h3" color="white">{heading}</Typography>
              <Typography varinat="content" color="white" className={classNames.text}>{hoverText}</Typography>
            </div>
            {ctaLink && (
              <CTALink
                cta={ctaCaption || gettext('Read more')}
                ctaURL={ctaLink}
                icon="chevron-right"
                type={ctaType}
              />
            )}
          </div>
        </div>
      </Col>
    )
  }), [data.items])

  return (
    <BlockWrapper>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Row>{images}</Row>
      </Container>
    </BlockWrapper>
  )
}
